const CHANGE_FEEDBACK_DEAL_CONDITIN = 'CHANGE_FEEDBACK_DEAL_CONDITIN';
const CHANGE_FEEDBACK_DEAL_PAGE = 'CHANGE_FEEDBACK_DEAL_PAGE';
const CHANGE_PROCUCT_KINDS_LIST = 'CHANGE_PROCUCT_KINDS_LIST';
const CHANGE_NEW_FEEDBACK_DEAL_CONDITION = 'CHANGE_NEW_FEEDBACK_DEAL_CONDITION';
const CHANGE_NEW_FEEDBACK_ADDGIFTBAG_CONDITION = 'CHANGE_NEW_FEEDBACK_ADDGIFTBAG_CONDITION';

const FeedBackDealListModel = function (){
    const name = 'feedback_deal_list';
    return {
        name,
        state:{
            condition:{
                dealUserId:'',
                dealStatus:'',
            },
            newModal:{
                dealUserId:'',
                remark:'',
                dealStatus:'',
                fbId:'',
                id:'',
            },
            addCondition:{   //更新为大礼包列表模态框的搜索条件
                productName:'',
                categoryId:'',
                publish	:'',
            },
            list:[],
            page:{
                pageSize:30,
                current:1,
                total:0,
            },
            // personList:[]
        },
        selectors:(state, props) => {
            const currentState = state[name];
            const selectors = {
                getCondition:()=>currentState.condition,
                getNewModalData:()=>currentState.newModal,
                getList:()=>currentState.list,
                getPage:()=>currentState.page,
                // getPersonList:()=>currentState.personList,
                getaddCondition:()=>currentState.addCondition,
            };
            return selectors;
        },
        api:{},
        actions:{
            changeCondition:(key,value) => (dispatch,getState) => {
                dispatch({
                    type:CHANGE_FEEDBACK_DEAL_CONDITIN,
                    key,
                    value
                })
            },
            changeNewModalData:(key,value) => (dispatch,getState) => {
                dispatch({
                    type:CHANGE_NEW_FEEDBACK_DEAL_CONDITION,
                    key,
                    value
                })
            },
            changeList:(list) => (dispatch,getState) => {
                dispatch({
                    type:CHANGE_PROCUCT_KINDS_LIST,
                    list
                })
            },
            changePage:(page) => (dispatch,getState) => {
                dispatch({
                    type:CHANGE_FEEDBACK_DEAL_PAGE,
                    page
                })
            },
            // changePersonList:(list) => (dispatch,getState) => {
            //     dispatch({
            //         type:'CHANGE_SERVICE_FOLLOW_UP_PERSON_LIST',
            //         list
            //     })
            // }
            changeaddCondition:(key,value) => (dispatch,getState) => {
                dispatch({
                    type:CHANGE_NEW_FEEDBACK_ADDGIFTBAG_CONDITION,
                    key,
                    value
                })
            },
        },
        reducers:{
            condition:(state = FeedBackDealListModel.state.condition, action) => {
                if(action.type === CHANGE_FEEDBACK_DEAL_CONDITIN){
                    const { key, value } = action;
                    const obj = {};
                    obj[key] = value;
                    return Object.assign({}, state, obj);
                }
                return state;
            },
            newModal:(state = FeedBackDealListModel.state.newModal, action) => {
                if(action.type === CHANGE_NEW_FEEDBACK_DEAL_CONDITION){
                    const { key, value } = action;
                    const obj = {};
                    obj[key] = value;
                    return Object.assign({}, state, obj);
                }
                return state;
            },
            page:(state = FeedBackDealListModel.state.page, action) => {
                if(action.type === CHANGE_FEEDBACK_DEAL_PAGE){
                    return Object.assign({}, state, action.page );
                }
                return state;
            },
            list:(state = FeedBackDealListModel.state.list , action ) => {
                if(action.type === CHANGE_PROCUCT_KINDS_LIST){
                    return [ ...action.list ];
                };
                return state;
            },
            // personList:(state = ServiceFollowUpModel.state.personList , action ) => {
            //     if(action.type === 'CHANGE_SERVICE_FOLLOW_UP_PERSON_LIST'){
            //         return [ ...action.list ];
            //     };
            //     return state;
            // }
            addCondition:(state = FeedBackDealListModel.state.addCondition, action) => {
                if(action.type === CHANGE_NEW_FEEDBACK_ADDGIFTBAG_CONDITION){
                    const { key, value } = action;
                    const obj = {};
                    obj[key] = value;
                    return Object.assign({}, state, obj);
                }
                return state;
            },
        }
    }
}();

export default FeedBackDealListModel;


// WEBPACK FOOTER //
// ./src/models/FeedBackDealListModel.js